import { render, staticRenderFns } from "./OrdinaryStore.vue?vue&type=template&id=47b5d03c&scoped=true&"
import script from "./OrdinaryStore.vue?vue&type=script&lang=js&"
export * from "./OrdinaryStore.vue?vue&type=script&lang=js&"
import style0 from "./OrdinaryStore.vue?vue&type=style&index=0&id=47b5d03c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5d03c",
  null
  
)

export default component.exports